// scripts/Loader.jsx
import React from "react";
import "../style/loader.css"; // Añade estilos para tu loader

const Loader = () => {
  return (
    <div className="loader-container">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
